import apiRequest from './apiRequest';
import type { BatchResponse } from './getBatch';

export type BatchType = 'COMIC' | 'GENERATION' | 'MASCOT';

export type BatchListItem = BatchResponse & {
  lastUpdatedAt?: string;
};

type BatchesApiResponse = {
  items?: BatchListItem[];
  batches?: BatchListItem[];
  nextToken?: string;
};

export type BatchesResponse = {
  items: BatchListItem[];
  nextToken?: string;
};

export type BatchListResponse = BatchesResponse;

export default async function getBatches(
  apiKey: string,
  options?: {
    limit?: number;
    nextToken?: string;
    type?: BatchType;
  },
): Promise<BatchListResponse> {
  const params = new URLSearchParams();
  if (options?.limit !== undefined) {
    params.set('limit', String(options.limit));
  }
  if (options?.type) {
    params.set('type', options.type);
  }
  if (options?.nextToken) {
    params.set('nextToken', options.nextToken);
  }

  const { data, error } = await apiRequest<BatchesApiResponse>(
    'external-mogen',
    `/batches${params.toString() ? `?${params.toString()}` : ''}`,
    {
      method: 'GET',
      headers: {
        'x-api-key': apiKey,
      },
    },
  );

  if (error) throw error;

  return {
    items: data?.items ?? data?.batches ?? [],
    nextToken: data?.nextToken,
  };
}
